const slideshowSelector = '.wp-block-tsp-gallery.is-style-slideshow, .wp-block-tsp-gallery.is-style-slideshow-fade';
const SLIDESHOW_FADE_STYLE_CLASS = 'is-style-slideshow-fade';
const CURRENT_SLIDE_CLASS = 'is-current-slide';
const HIDDEN_SLIDE_CLASS = 'is-hidden-slide';
const ENTERING_SLIDE_CLASS = 'is-entering-slide';
const ACTIVE_DOT_CLASS = 'is-active-dot';
const TRANSITION_MS = 350;

const getSlides = (gallery) => {
	return Array.from(gallery.children).filter((item) => {
		if (item.nodeType !== 1) {
			return false;
		}

		return Boolean(item.querySelector('img, video'));
	});
};

const updateDots = (dots, currentIndex) => {
	dots.forEach((dot, index) => {
		const isActive = index === currentIndex;
		dot.classList.toggle(ACTIVE_DOT_CLASS, isActive);
		dot.setAttribute('aria-current', isActive ? 'true' : 'false');
	});
};

const createArrow = (direction, onClick) => {
	const button = document.createElement('button');
	button.type = 'button';
	button.className = `tsp-gallery-slideshow__arrow tsp-gallery-slideshow__arrow--${direction}`;
	button.setAttribute(
		'aria-label',
		direction === 'prev' ? 'Show previous image' : 'Show next image'
	);
	button.textContent = direction === 'prev' ? '‹' : '›';
	button.addEventListener('click', onClick);

	return button;
};

const initSlideshow = (gallery) => {
	const slides = getSlides(gallery);
	if (slides.length < 1) {
		return;
	}
	const isFadeSlideshow = gallery.classList.contains(SLIDESHOW_FADE_STYLE_CLASS);

	gallery.classList.add('tsp-gallery-slideshow');
	if (isFadeSlideshow) {
		gallery.classList.add('tsp-gallery-slideshow--fade');
	}

	let currentIndex = 0;
	let isAnimating = false;

	const dotsContainer = document.createElement('div');
	dotsContainer.className = 'tsp-gallery-slideshow__dots';

	const dots = slides.map((_, index) => {
		const dot = document.createElement('button');
		dot.type = 'button';
		dot.className = 'tsp-gallery-slideshow__dot';
		dot.setAttribute('aria-label', `Show image ${index + 1}`);
		dot.addEventListener('click', () => {
			if (index === currentIndex) {
				return;
			}

			const direction = index > currentIndex ? 'next' : 'prev';
			goToSlide(index, direction);
		});
		dotsContainer.appendChild(dot);
		return dot;
	});

	const showInitialState = () => {
		slides.forEach((slide, index) => {
			slide.classList.remove(CURRENT_SLIDE_CLASS, HIDDEN_SLIDE_CLASS, ENTERING_SLIDE_CLASS);
			slide.style.transform = 'translateX(0)';
			slide.style.opacity = '1';
			slide.style.transition = 'none';

			if (index === currentIndex) {
				slide.classList.add(CURRENT_SLIDE_CLASS);
			} else {
				slide.classList.add(HIDDEN_SLIDE_CLASS);
			}
		});

		updateDots(dots, currentIndex);
	};

	const goToSlide = (nextIndex, direction) => {
		if (isAnimating || nextIndex === currentIndex) {
			return;
		}

		isAnimating = true;

		const currentSlide = slides[currentIndex];
		const nextSlide = slides[nextIndex];
		const nextStartTransform = direction === 'next' ? 'translateX(100%)' : 'translateX(-100%)';
		const currentEndTransform = direction === 'next' ? 'translateX(-100%)' : 'translateX(100%)';

		nextSlide.classList.remove(HIDDEN_SLIDE_CLASS);
		nextSlide.classList.add(ENTERING_SLIDE_CLASS);
		nextSlide.style.transition = 'none';
		currentSlide.style.transition = 'none';
		nextSlide.style.transform = isFadeSlideshow ? 'translateX(0)' : nextStartTransform;
		currentSlide.style.transform = 'translateX(0)';
		nextSlide.style.opacity = isFadeSlideshow ? '0' : '1';
		currentSlide.style.opacity = '1';
		void nextSlide.offsetWidth;

		requestAnimationFrame(() => {
			if (isFadeSlideshow) {
				nextSlide.style.transition = `opacity ${TRANSITION_MS}ms ease`;
				currentSlide.style.transition = `opacity ${TRANSITION_MS}ms ease`;
				nextSlide.style.opacity = '1';
				currentSlide.style.opacity = '0';
				return;
			}

			nextSlide.style.transition = `transform ${TRANSITION_MS}ms ease`;
			currentSlide.style.transition = `transform ${TRANSITION_MS}ms ease`;
			nextSlide.style.transform = 'translateX(0)';
			currentSlide.style.transform = currentEndTransform;
		});

		const onSlideEnd = () => {
			nextSlide.removeEventListener('transitionend', onSlideEnd);

			currentSlide.classList.remove(CURRENT_SLIDE_CLASS);
			currentSlide.classList.add(HIDDEN_SLIDE_CLASS);
			currentSlide.style.transition = 'none';
			currentSlide.style.transform = 'translateX(0)';
			currentSlide.style.opacity = '1';

			nextSlide.classList.remove(ENTERING_SLIDE_CLASS);
			nextSlide.classList.add(CURRENT_SLIDE_CLASS);
			nextSlide.style.transition = 'none';
			nextSlide.style.transform = 'translateX(0)';
			nextSlide.style.opacity = '1';

			currentIndex = nextIndex;
			updateDots(dots, currentIndex);
			isAnimating = false;
		};

		nextSlide.addEventListener('transitionend', onSlideEnd, { once: true });
	};

	const goToPrevious = () => {
		const nextIndex = (currentIndex - 1 + slides.length) % slides.length;
		goToSlide(nextIndex, 'prev');
	};

	const goToNext = () => {
		const nextIndex = (currentIndex + 1) % slides.length;
		goToSlide(nextIndex, 'next');
	};

	gallery.appendChild(createArrow('prev', goToPrevious));
	gallery.appendChild(createArrow('next', goToNext));
	gallery.insertAdjacentElement('afterend', dotsContainer);

	showInitialState();
};

document.querySelectorAll(slideshowSelector).forEach(initSlideshow);

